import React from "react";

const STATUS_LABEL = {
  pending: "Pending",
  running: "Running",
  succeeded: "Succeeded",
  skipped_already_exists: "Skipped (exists)",
  skipped_missing_data: "Skipped (missing data)",
  skipped_hidden_row: "Skipped (hidden row)",
  skipped_invalid_url: "Skipped (bad URL)",
  failed: "Failed",
};

const PUBLISH_LABEL = {
  pending: "Pending",
  publishing: "Publishing…",
  published: "Published",
  failed: "Failed",
};

function truncate(text, n) {
  if (!text) return "";
  return text.length > n ? text.slice(0, n) + "…" : text;
}

/** The "Live" cell: where this report stands in the live Dashboards folder. */
function LiveCell({ publish }) {
  if (!publish || !publish.status) return "—";
  const badge = (
    <span className={`bfr-status-badge publish-${publish.status}`}>
      {PUBLISH_LABEL[publish.status] || publish.status}
    </span>
  );
  if (publish.status === "published" && publish.live_file_url) {
    return (
      <>
        {badge}{" "}
        <a href={publish.live_file_url} target="_blank" rel="noopener noreferrer">Open ↗</a>
      </>
    );
  }
  if (publish.status === "failed") {
    return (
      <span title={publish.error || ""}>
        {badge} <span className="bfr-publish-error">{truncate(publish.error, 60)}</span>
      </span>
    );
  }
  return badge;
}

export default function RowResultsTable({ rows }) {
  if (!rows || rows.length === 0) {
    return <div className="bfr-row-table-empty">No rows yet.</div>;
  }
  return (
    <table className="bfr-row-table">
      <thead>
        <tr>
          <th>Row</th>
          <th>Franchisee</th>
          <th>Store</th>
          <th>Status</th>
          <th>Drive</th>
          <th>Live</th>
          <th>Error</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.sheet_row_number} className={r.status}>
            <td>{r.sheet_row_number}</td>
            <td>{r.franchisee || "—"}</td>
            <td>{r.adj_store_name || "—"}</td>
            <td>
              <span className={`bfr-status-badge ${r.status}`}>
                {STATUS_LABEL[r.status] || r.status}
              </span>
            </td>
            <td>
              {r.drive_file_url ? (
                <a href={r.drive_file_url} target="_blank" rel="noopener noreferrer">Open ↗</a>
              ) : "—"}
            </td>
            <td><LiveCell publish={r.publish} /></td>
            <td title={r.error || ""}>
              {r.error ? truncate(r.error, 80) : "—"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
